import { Card, Tab } from '@features/ui';
import { FC, useMemo, useState } from 'react';
import { TTab } from '@src/types';
import { useTranslation } from 'react-i18next';
import { GeneralUser } from '@features/admin/users/GeneralUser.tsx';
import { RithmicUser } from '@features/admin/users/RithmicUser.tsx';
// import { TradovateUser } from '@features/admin/users/TradovateUser.tsx';
import { PayoutInfo } from '@features/admin/users/PayoutInfo.tsx';
import { UserProfile } from '@src/types/users.ts';

interface UsersInfoProps {
  user: UserProfile | null;
  onUserUpdate?: (updatedUser: UserProfile) => void;
  onUserRithmicUpdate?: () => void;
  onResendWelcomeEmail?: () => void;
  refreshUser?: () => void;
}
export const UsersInfo: FC<UsersInfoProps> = ({
  user,
  // onUserUpdate,
  refreshUser,
  onUserRithmicUpdate,
  onResendWelcomeEmail,
}) => {
  const [tabActive, setTabActive] = useState(0);

  const { t } = useTranslation();

  const tabs: TTab[] = useMemo(
    () => [
      {
        label: t('users.tab.general'),
        component: <GeneralUser user={user} />,
      },
      {
        label: t('users.tab.rithmic'),
        component: (
          <RithmicUser
            user={user}
            onResendWelcomeEmail={onResendWelcomeEmail}
            onUpdateRithmic={onUserRithmicUpdate}
          />
        ),
      },
      // {
      //   label: t('users.tab.tradovate'),
      //   component: <TradovateUser user={user} />,
      // },
      // {
      //   label: t('users.tab.dxFeed'),
      //   component: <></>,
      //   disabled: true,
      // },
      {
        label: t('users.tab.payoutInfo'),
        component: <PayoutInfo refreshUser={refreshUser} user={user} />,
      },
    ],
    [t, user, refreshUser]
  );

  return (
    <Card className={'flex-1 pt-3 pl-7.5 pr-[9]'}>
      <Tab
        className={'mb-4 pb-1'}
        size={'sm'}
        tabActive={tabActive}
        tabs={tabs}
        onChangeTab={setTabActive}
      />
    </Card>
  );
};
